import {SimpleStat} from './simple-stat';
import {Document} from '../document';

export class ProductStat extends SimpleStat {
  label: string = '';
  productId: number | null = null;
  logo: Document | null = null;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.logoId) {
      this.logo = new Document().deserialize({id: input.logoId});
    }

    return this;
  }
}
